import { from, Observable, of, switchMap, map } from 'rxjs';
import { StorageService } from './storage'; 
import { BaseApiService } from './base-api-service';

export abstract class BaseEntityService<T> {
  constructor(
    protected readonly baseApi: BaseApiService,
    protected readonly storageService: StorageService<T>,
    private readonly dbName: string,
    private readonly storeName: string,
    private readonly apiPath: string
  ) { }

  get(forced = false): Observable<T[]> {
    if (forced) {
      return this.fetchAndCache();
    }

    return from(this.storageService.getAll(this.dbName, this.storeName)).pipe(
      switchMap(cached => {
        if (cached.length > 0) {
          console.log(`Loaded ${this.storeName} from local storage`);
          return of(cached);
        } else {
          return this.fetchAndCache();
        }
      })
    );
  }

  private fetchAndCache(): Observable<T[]> {
    return this.baseApi.post<any>(this.apiPath, {}).pipe(
      map(response => response?.result ?? []),
      switchMap(items => from(this.storageService.putAll(this.dbName, this.storeName, items)))
    );
  }
}
